"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.role = exports.guild = exports.user = void 0;
var axios_1 = __importDefault(require("axios"));
var auth_1 = require("./auth");
var common_1 = require("./common");
var types_1 = require("./types");
var user = {
    getMemberships: function (address) {
        return __awaiter(this, void 0, void 0, function () {
            var res, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4, axios_1.default.get("".concat(common_1.globals.apiBaseUrl, "/user/membership/").concat(address), { headers: common_1.globals.headers })];
                    case 1:
                        res = _a.sent();
                        return [2, res === null || res === void 0 ? void 0 : res.data];
                    case 2:
                        error_1 = _a.sent();
                        if (axios_1.default.isAxiosError(error_1) && error_1.response.data.errors) {
                            throw new types_1.ApiError(error_1.response.data.errors);
                        }
                        else {
                            throw error_1;
                        }
                        return [3, 3];
                    case 3: return [2];
                }
            });
        });
    },
    join: function (guildId, signerAddress, sign, platforms) {
        return __awaiter(this, void 0, void 0, function () {
            var body, res, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4, (0, auth_1.prepareBodyWithSign)(signerAddress, sign, {
                                guildId: guildId,
                                platforms: platforms,
                            })];
                    case 1:
                        body = _a.sent();
                        return [4, axios_1.default.post("".concat(common_1.globals.apiBaseUrl, "/user/join/"), body, {
                                headers: common_1.globals.headers,
                            })];
                    case 2:
                        res = _a.sent();
                        return [2, res === null || res === void 0 ? void 0 : res.data];
                    case 3:
                        error_2 = _a.sent();
                        if (axios_1.default.isAxiosError(error_2) && error_2.response.data.errors) {
                            throw new types_1.ApiError(error_2.response.data.errors);
                        }
                        else {
                            throw error_2;
                        }
                        return [3, 4];
                    case 4: return [2];
                }
            });
        });
    },
};
exports.user = user;
var guild = {
    getAll: function (query) {
        if (query === void 0) { query = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var queryParams, searchParams, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParams = {};
                        if (query.order)
                            queryParams.order = query.order;
                        if (query.search)
                            queryParams.search = query.search;
                        searchParams = new URLSearchParams(queryParams).toString();
                        return [4, axios_1.default.get("".concat(common_1.globals.apiBaseUrl, "/guild?").concat(searchParams), {
                                headers: common_1.globals.headers,
                            })];
                    case 1:
                        res = _a.sent();
                        return [2, res === null || res === void 0 ? void 0 : res.data];
                }
            });
        });
    },
    getByAddress: function (address, query) {
        var _a;
        if (query === void 0) { query = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var queryParams, searchParams, res;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        queryParams = {};
                        if (query.order)
                            queryParams.order = query.order;
                        if (query.search)
                            queryParams.search = query.search;
                        queryParams.include = (_a = query.include) !== null && _a !== void 0 ? _a : "all";
                        searchParams = new URLSearchParams(queryParams).toString();
                        return [4, axios_1.default.get("".concat(common_1.globals.apiBaseUrl, "/guild/address/").concat(address, "?").concat(searchParams), { headers: common_1.globals.headers })];
                    case 1:
                        res = _b.sent();
                        return [2, res === null || res === void 0 ? void 0 : res.data];
                }
            });
        });
    },
    get: function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, axios_1.default.get("".concat(common_1.globals.apiBaseUrl, "/guild/").concat(id), {
                            headers: common_1.globals.headers,
                        })];
                    case 1:
                        res = _a.sent();
                        if (res.status === 204) {
                            return [2, null];
                        }
                        return [2, res === null || res === void 0 ? void 0 : res.data];
                }
            });
        });
    },
    getUserAccess: function (guildId, address) {
        return __awaiter(this, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, axios_1.default.get("".concat(common_1.globals.apiBaseUrl, "/guild/access/").concat(guildId, "/").concat(address), { headers: common_1.globals.headers })];
                    case 1:
                        res = _a.sent();
                        return [2, res === null || res === void 0 ? void 0 : res.data];
                }
            });
        });
    },
    getUserMemberships: function (guildId, address) {
        return __awaiter(this, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, axios_1.default.get("".concat(common_1.globals.apiBaseUrl, "/guild/member/").concat(guildId, "/").concat(address), { headers: common_1.globals.headers })];
                    case 1:
                        res = _a.sent();
                        return [2, res === null || res === void 0 ? void 0 : res.data];
                }
            });
        });
    },
    create: function (signerAddress, sign, params) {
        return __awaiter(this, void 0, void 0, function () {
            var body, res, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, (0, auth_1.prepareBodyWithSign)(signerAddress, sign, params)];
                    case 1:
                        body = _a.sent();
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 4, , 5]);
                        return [4, axios_1.default.post("".concat(common_1.globals.apiBaseUrl, "/guild"), body, {
                                headers: common_1.globals.headers,
                            })];
                    case 3:
                        res = _a.sent();
                        return [2, res === null || res === void 0 ? void 0 : res.data];
                    case 4:
                        error_3 = _a.sent();
                        if (axios_1.default.isAxiosError(error_3) && error_3.response.data.errors) {
                            throw new types_1.ApiError(error_3.response.data.errors);
                        }
                        else {
                            throw error_3;
                        }
                        return [3, 5];
                    case 5: return [2];
                }
            });
        });
    },
    update: function (id, signerAddress, sign, params) {
        return __awaiter(this, void 0, void 0, function () {
            var body, res, error_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, (0, auth_1.prepareBodyWithSign)(signerAddress, sign, params)];
                    case 1:
                        body = _a.sent();
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 4, , 5]);
                        return [4, axios_1.default.patch("".concat(common_1.globals.apiBaseUrl, "/guild/").concat(id), body, {
                                headers: common_1.globals.headers,
                            })];
                    case 3:
                        res = _a.sent();
                        return [2, res === null || res === void 0 ? void 0 : res.data];
                    case 4:
                        error_4 = _a.sent();
                        if (axios_1.default.isAxiosError(error_4) && error_4.response.data.errors) {
                            throw new types_1.ApiError(error_4.response.data.errors);
                        }
                        else {
                            throw error_4;
                        }
                        return [3, 5];
                    case 5: return [2];
                }
            });
        });
    },
    delete: function (id, signerAddress, sign, removePlatformAccess) {
        if (removePlatformAccess === void 0) { removePlatformAccess = false; }
        return __awaiter(this, void 0, void 0, function () {
            var body, res, error_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, (0, auth_1.prepareBodyWithSign)(signerAddress, sign, {
                            removePlatformAccess: removePlatformAccess,
                        })];
                    case 1:
                        body = _a.sent();
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 4, , 5]);
                        return [4, axios_1.default.delete("".concat(common_1.globals.apiBaseUrl, "/guild/").concat(id), {
                                data: body,
                                headers: common_1.globals.headers,
                            })];
                    case 3:
                        res = _a.sent();
                        return [2, res === null || res === void 0 ? void 0 : res.data];
                    case 4:
                        error_5 = _a.sent();
                        if (axios_1.default.isAxiosError(error_5) && error_5.response.data.errors) {
                            throw new types_1.ApiError(error_5.response.data.errors);
                        }
                        else {
                            throw error_5;
                        }
                        return [3, 5];
                    case 5: return [2];
                }
            });
        });
    },
};
exports.guild = guild;
var role = {
    get: function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, axios_1.default.get("".concat(common_1.globals.apiBaseUrl, "/role/").concat(id), {
                            headers: common_1.globals.headers,
                        })];
                    case 1:
                        res = _a.sent();
                        if (res.status === 204) {
                            return [2, null];
                        }
                        return [2, res === null || res === void 0 ? void 0 : res.data];
                }
            });
        });
    },
    create: function (signerAddress, sign, params) {
        return __awaiter(this, void 0, void 0, function () {
            var body, res, error_6;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, (0, auth_1.prepareBodyWithSign)(signerAddress, sign, params)];
                    case 1:
                        body = _a.sent();
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 4, , 5]);
                        return [4, axios_1.default.post("".concat(common_1.globals.apiBaseUrl, "/role"), body, {
                                headers: common_1.globals.headers,
                            })];
                    case 3:
                        res = _a.sent();
                        return [2, res === null || res === void 0 ? void 0 : res.data];
                    case 4:
                        error_6 = _a.sent();
                        if (axios_1.default.isAxiosError(error_6) && error_6.response.data.errors) {
                            throw new types_1.ApiError(error_6.response.data.errors);
                        }
                        else {
                            throw error_6;
                        }
                        return [3, 5];
                    case 5: return [2];
                }
            });
        });
    },
    update: function (id, signerAddress, sign, params) {
        return __awaiter(this, void 0, void 0, function () {
            var body, res, error_7;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, (0, auth_1.prepareBodyWithSign)(signerAddress, sign, params)];
                    case 1:
                        body = _a.sent();
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 4, , 5]);
                        return [4, axios_1.default.patch("".concat(common_1.globals.apiBaseUrl, "/role/").concat(id), body, {
                                headers: common_1.globals.headers,
                            })];
                    case 3:
                        res = _a.sent();
                        return [2, res === null || res === void 0 ? void 0 : res.data];
                    case 4:
                        error_7 = _a.sent();
                        if (axios_1.default.isAxiosError(error_7) && error_7.response.data.errors) {
                            throw new types_1.ApiError(error_7.response.data.errors);
                        }
                        else {
                            throw error_7;
                        }
                        return [3, 5];
                    case 5: return [2];
                }
            });
        });
    },
    delete: function (id, signerAddress, sign, removePlatformAccess) {
        if (removePlatformAccess === void 0) { removePlatformAccess = false; }
        return __awaiter(this, void 0, void 0, function () {
            var body, res, error_8;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, (0, auth_1.prepareBodyWithSign)(signerAddress, sign, {
                            removePlatformAccess: removePlatformAccess,
                        })];
                    case 1:
                        body = _a.sent();
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 4, , 5]);
                        return [4, axios_1.default.delete("".concat(common_1.globals.apiBaseUrl, "/role/").concat(id), {
                                data: body,
                                headers: common_1.globals.headers,
                            })];
                    case 3:
                        res = _a.sent();
                        return [2, res === null || res === void 0 ? void 0 : res.data];
                    case 4:
                        error_8 = _a.sent();
                        if (axios_1.default.isAxiosError(error_8) && error_8.response.data.errors) {
                            throw new types_1.ApiError(error_8.response.data.errors);
                        }
                        else {
                            throw error_8;
                        }
                        return [3, 5];
                    case 5: return [2];
                }
            });
        });
    },
};
exports.role = role;
